import React, { ForwardedRef } from 'react';
import cx from 'classnames';
import './BaseForm.scss';

interface BaseFormProps {
  className?: string;
  vertical?: boolean;
  required?: boolean;
  label: string | React.ReactNode;
  subContent?: string | React.ReactNode;
  content?: string | React.ReactNode;
}

const BaseForm = (props: BaseFormProps, ref: ForwardedRef<HTMLDivElement>) => {
  const { className, vertical = false, required = false, label, subContent, content } = props;

  return (
    <div className={cx('base-form', 'amondz-form', { required }, { vertical }, className)}>
      <div className="label">{label}</div>

      <div className="content" ref={ref}>
        {content}

        {subContent ? <div className="amondz-form-sub-content"> {subContent} </div> : null}
      </div>
    </div>
  );
};

export default React.forwardRef<HTMLDivElement, BaseFormProps>(BaseForm);
